import React, {Component} from 'react';
import {connect} from 'formik';
import get from 'lodash/get';
import classNames from 'classnames';

class MultipleNumber3Field extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.props.formik.registerField(this.props.id, this);
    }

    componentWillUnmount() {
        this.props.formik.unregisterField(this.props.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.id !== prevProps.id) {
            this.props.formik.unregisterField(prevProps.id);
            this.props.formik.registerField(this.props.id, this);
        }
    }

    handleChange(e) {
        const rowId = e.target.dataset.id;
        const {formik, id, value} = this.props;
        const newValue = Object.assign({}, value);
        newValue[rowId] = e.target.value;
        formik.setFieldValue(id, newValue);
    }

    render() {
        const {form, field, rows, max} = this.props;

        const errorRows = get(form.errors, `${field.name}.reasonParams.0.errorRows`, []);

        return (
            <div className="comp-container" >
                {rows.map((row, rowIndex) => (
                    <div key={row.id} className="comp-row form-group">
                        <div className="pr10">
                            <input type="number"
                                name={row.id}
                                data-id={row.id}
                                className={classNames({
                                    'form-control': true,
                                    'force-error': errorRows.includes(row.id),
                                })}
                                onChange={this.handleChange}
                                max={max}
                                required
                            />
                        </div>
                        <div className= "comp-label" dangerouslySetInnerHTML={{__html: row.label}} />
                    </div>
                ))}
            </div>
        );
    }
}

export default connect(MultipleNumber3Field);
